// @codekit-prepend 'jarallax.min.js'
// @codekit-prepend 'jarallax-element.min.js'
// @codekit-prepend 'parallax.min.js'
// @codekit-prepend 'owl.carousel.js'
// @codekit-prepend 'jquery.cycle.lite.js'
// @codekit-prepend 'lottie.js'
// @codekit-prepend 'jquery.paroller.js'
// @codekit-prepend 'jquery.countdown.js'
// @codekit-prepend 'jquery.flip.js'
// @codekit-prepend 'readmore.js'
// @codekit-prepend 'jquery.custom-scrollbar.js'
// @codekit-prepend 'basicScroll.min.js'

$('html, body').animate({ scrollTop: 0 }, 1)

$(document).on('touchmove', function(e) {
  e.preventDefault()
})

$('html').css({
  'overflow': 'hidden',
  'height': '100%'
})

window.onload = function() {
  // console.log('loaded')

  $('.m-spinner').css('opacity', '0')

  setTimeout(() => {
    $('.m-loader').css('opacity', '0')

    setTimeout(() => {
      $('.m-loader').css('display', 'none')
    }, 500)

    $('html').css({
      'overflow': 'auto',
      'height': 'auto'
    })

    $(document).unbind('touchmove')
  }, 500)
}

$(document).ready(() => {
  const MOBILE = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;

  function Utils() {}

  Utils.prototype = {
    constructor: Utils,
    isElementInView: function (element, desktopOffset, mobileOffset) {
      desktopOffset = (typeof desktopOffset !== 'undefined') ? desktopOffset : ($(window).height() / 3);
      mobileOffset = (typeof mobileOffset !== 'undefined') ? mobileOffset : ($(window).height() / 2);

      var pageTop = $(window).scrollTop();
      var pageBottom = pageTop + $(window).height();
      var elementTop;

      if (MOBILE) {
        elementTop = $(element).offset().top + mobileOffset;
      } else {
        elementTop = $(element).offset().top + desktopOffset;
      }

      var elementBottom = elementTop + $(element).height();

      return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
    }
  };

  var Utils = new Utils();

  var statsBlocks;
  var heartCard;
  var heartbeat;
  var personalCard;
  var ship;
  var car;
  var triangleRadio1;
  var triangleRadio2;
  var triangleRadio3;
  var flaskAnim;
  var pipesAnim;
  var tubesAnim;
  var suitAnim;
  var ecosystemAnim;
  var headAnim;
  var balloonAnim;
  var mobileAnim;
  var suitcaseAnim;
  var bitwalletAnim;
  var mapAnim;
  var stethoscopeAnim;
  var documentsAnim;

  if ($('#m-stats-blocks').length) {
    statsBlocks = lottie.loadAnimation({
      wrapper: document.getElementById('m-stats-blocks'),
      animType: 'svg',
      loop: false,
      autoplay: false,
      path: 'data/stats-blocks.json'
    })
  }

  if ($('#m-heart-card').length) {
    heartCard = lottie.loadAnimation({
      wrapper: document.getElementById('m-heart-card'),
      animType: 'svg',
      loop: true,
      autoplay: MOBILE ? false : true,
      path: 'data/heart-card.json'
    })
  }

  if ($('#m-heartbeat').length) {
    heartbeat = lottie.loadAnimation({
      wrapper: document.getElementById('m-heartbeat'),
      animType: 'svg',
      loop: true,
      autoplay: MOBILE ? false : true,
      path: 'data/heartbeat.json'
    })
  }

  if ($('#m-personal-card').length) {
    personalCard = lottie.loadAnimation({
      wrapper: document.getElementById('m-personal-card'),
      animType: 'svg',
      loop: true,
      autoplay: MOBILE ? false : true,
      path: 'data/personal-card.json'
    })
  }

  if ($('#m-ship').length) {
    ship = lottie.loadAnimation({
      wrapper: document.getElementById('m-ship'),
      animType: 'svg',
      loop: false,
      autoplay: false,
      path: 'data/ship2.json'
    })
  }

  if ($('#m-car').length) {
    car = lottie.loadAnimation({
      wrapper: document.getElementById('m-car'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/car-tyre.json'
    })
  }

  if ($('#triangle-radio1').length) {
    triangleRadio1 = lottie.loadAnimation({
      wrapper: document.getElementById('triangle-radio1'),
      animType: 'svg',
      loop: false,
      autoplay: false,
      path: 'data/building-radio.json'
    })
  }

  if ($('#triangle-radio2').length) {
    triangleRadio2 = lottie.loadAnimation({
      wrapper: document.getElementById('triangle-radio2'),
      animType: 'svg',
      loop: false,
      autoplay: false,
      path: 'data/building-radio.json'
    })
  }

  if ($('#triangle-radio3').length) {
    triangleRadio3 = lottie.loadAnimation({
      wrapper: document.getElementById('triangle-radio3'),
      animType: 'svg',
      loop: false,
      autoplay: false,
      path: 'data/building-radio.json'
    })
  }

  if ($('#m-flask').length) {
    flaskAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-flask'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/flask.json'
    })
  }

  if ($('#m-pipes').length) {
    pipesAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-pipes'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/pipes.json'
    })
  }

  if ($('#m-tubes').length) {
    tubesAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-tubes'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/tubes.json'
    })
  }

  if ($('#m-suit-left').length) {
    suitAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-suit-left'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/suit-left.json'
    })
  }

  if ($('#m-ecosystem-plus').length) {
    ecosystemAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-ecosystem-plus'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/ecosystem-plus.json'
    })
  }

  if ($('#m-head-icon').length) {
    headAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-head-icon'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/head.json'
    })
  }

  if ($('#m-balloon-icon').length) {
    balloonAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-balloon-icon'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/balloon.json'
    })
  }

  if ($('#m-mobile-icon').length) {
    mobileAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-mobile-icon'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/mobile.json'
    })
  }

  if ($('#m-suitcase-icon').length) {
    suitcaseAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-suitcase-icon'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/suitcase.json'
    })
  }

  if ($('#m-bitwallet-icon').length) {
    bitwalletAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-bitwallet-icon'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/bitwallet.json'
    })
  }

  if ($('#m-map-icon').length) {
    mapAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-map-icon'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/map.json'
    })
  }

  if ($('#m-token-stethoscope').length) {
    stethoscopeAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-token-stethoscope'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/stethoscope.json'
    })
  }

  if ($('#m-documents').length) {
    documentsAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-documents'),
      animType: 'svg',
      loop: true,
      autoplay: false,
      path: 'data/documents.json'
    })
  }

  var subscribeShown = false;

  if ($('#m-news-block').length) {
    if (!$('#m-news-block').hasClass('media')) {
      $(window).scroll(function() {
        var isBlockchainInView;
        var isBuildingBlockInView;
        var isInfoBlockInView;
        var isSuitBlockInView;
        var isEcosystemBlockInView;
        var isCarouselBlockInView;
        var isStethoscopeBlockInView;
        var isInvestmentBlockInView;
        var isFeaturesBlockInView;
        var isConceptBlockInView;

        if ($('.m-blockchain-svg').length) {
          isBlockchainInView = Utils.isElementInView($('.m-blockchain-svg'));
        }

        if ($('#m-buildings').length) {
          isBuildingBlockInView = Utils.isElementInView($('#m-buildings'));
        }

        if ($('.m-info').length) {
          isInfoBlockInView = Utils.isElementInView($('.m-info'));
        }

        if ($('.m-suit-wrapper').length) {
          isSuitBlockInView = Utils.isElementInView($('.m-suit-wrapper'));
        }

        if ($('.m-ecosystem-block').length) {
          isEcosystemBlockInView = Utils.isElementInView($('.m-ecosystem-block'));
        }

        if ($('.m-carousel').length) {
          isCarouselBlockInView = Utils.isElementInView($('.m-carousel'));
        }

        if ($('#m-token-stethoscope').length) {
          isStethoscopeBlockInView = Utils.isElementInView($('#m-token-stethoscope'));
        }

        if ($('#m-investment-block').length) {
          isInvestmentBlockInView = Utils.isElementInView($('#m-investment-block'));
        }

        if ($('#m-features-block').length) {
          isFeaturesBlockInView = Utils.isElementInView($('#m-features-block'), 0, 0);
        }

        if ($('.m-concept-block').length) {
          isConceptBlockInView = Utils.isElementInView($('.m-concept-block'));
        }

        if (isBlockchainInView) {
          statsBlocks.play()
          heartCard.play()
          heartbeat.play()
          personalCard.play()
        } else {
          statsBlocks.stop()
          heartCard.stop()
          heartbeat.stop()
          personalCard.stop()
        }

        if (isBuildingBlockInView) {
          triangleRadio1.play()
          triangleRadio2.play()
          triangleRadio3.play()

          triangleRadio1.addEventListener('complete', function() {
            triangleRadio1.stop()
            $('#triangle-radio1').css('opacity', 0)
            setTimeout(function() {
              triangleRadio1.goToAndPlay(0, true)
              $('#triangle-radio1').css('opacity', 1)
            }, 3000)
          })

          triangleRadio2.addEventListener('complete', function() {
            triangleRadio2.stop()
            $('#triangle-radio2').css('opacity', 0)
            setTimeout(function() {
              triangleRadio2.goToAndPlay(0, true)
              $('#triangle-radio2').css('opacity', 1)
            }, 6000)
          })

          triangleRadio3.addEventListener('complete', function() {
            triangleRadio3.stop()
            $('#triangle-radio3').css('opacity', 0)
            setTimeout(function() {
              triangleRadio3.goToAndPlay(0, true)
              $('#triangle-radio3').css('opacity', 1)
            }, 9000)
          })

          car.play()

          if (MOBILE) {
            ship.goToAndPlay(1140, true)
          } else {
            ship.play()
          }

          ship.addEventListener('complete', function() {
            ship.goToAndPlay(1140, true)
          })
        } else {
          triangleRadio1.stop()
          triangleRadio2.stop()
          triangleRadio3.stop()
          car.stop()
          ship.stop()
        }

        if (isInfoBlockInView) {
          flaskAnim.play()
          tubesAnim.play()
          pipesAnim.play()
        } else {
          flaskAnim.stop()
          tubesAnim.stop()
          pipesAnim.stop()
        }

        if (isSuitBlockInView) {
          suitAnim.play()
        } else {
          suitAnim.stop()
        }

        if (isEcosystemBlockInView) {
          ecosystemAnim.play()
        } else {
          ecosystemAnim.stop()
        }

        if (isCarouselBlockInView) {
          headAnim.play()
          balloonAnim.play()
          mobileAnim.play()
          suitcaseAnim.play()
          bitwalletAnim.play()
          mapAnim.play()
        } else {
          headAnim.stop()
          balloonAnim.stop()
          mobileAnim.stop()
          suitcaseAnim.stop()
          bitwalletAnim.stop()
          mapAnim.stop()
        }

        if (isStethoscopeBlockInView) {
          stethoscopeAnim.play()
        } else {
          stethoscopeAnim.stop()
        }

        if (isInvestmentBlockInView) {
          documentsAnim.play()
        } else {
          documentsAnim.stop()
        }

        if (isFeaturesBlockInView) {
          if (!subscribeShown) {
            $('.m-subscribe-investor').addClass('show')
            subscribeShown = true;
          }
        }

        if (isConceptBlockInView) {
          $('.m-concept-block .concept-buildings .buildings-bg').css({
            '-webkit-animation-play-state': 'running',
            '-moz-animation-play-state': 'running',
            '-o-animation-play-state': 'running',
            'animation-play-state': 'running'
          })
        } else {
          $('.m-concept-block .concept-buildings .buildings-bg').css({
            '-webkit-animation-play-state': 'paused',
            '-moz-animation-play-state': 'paused',
            '-o-animation-play-state': 'paused',
            'animation-play-state': 'paused'
          })
        }
      })
    }
  }

  if ($('.m-subscribe-investor').length) {
    $('.m-subscribe-investor .m-close a').click(function(e) {
      e.preventDefault();
      $('.m-subscribe-investor').removeClass('show')
    })
  }

  // Add slideDown animation to Bootstrap dropdown when expanding
  $('.dropdown').on('show.bs.dropdown', function() {
    $(this).find('.dropdown-menu').first().stop(true, true).slideDown(250);
  });

  // Add slideUp animation to Bootstrap dropdown when collapsing
  $('.dropdown').on('hide.bs.dropdown', function() {
    $(this).find('.dropdown-menu').first().stop(true, true).slideUp(250);
  });

  var menuPlus;
  var faqPlus;

  if ($('.m-menu-plus').length) {
    menuPlus = new Parallax(document.querySelector('.m-menu-plus'), {
      calibrateX: true,
      originY: 0,
      originX: 0
    });
  }

  if ($('.m-faq-plus').length) {
    faqPlus = new Parallax(document.querySelector('.m-faq-plus'), {
      calibrateX: true,
      originY: 0,
      originX: 0
    });
  }

  var arrowAnim;

  if ($('#m-arrow-down').length) {
    arrowAnim = lottie.loadAnimation({
      wrapper: document.getElementById('m-arrow-down'),
      animType: 'svg',
      loop: true,
      autoplay: true,
      path: 'data/arrow-down.json'
    })
  }

  var menuBurgerAnim;

  if ($('#menu-burger').length) {
    menuBurgerAnim = lottie.loadAnimation({
      wrapper: document.getElementById('menu-burger'),
      animType: 'svg',
      loop: false,
      autoplay: false,
      path: 'data/burger.json'
    })
  }


  let menuBurger = $('#menu-burger')
  let menuOpen = false

  menuBurger.click(function(e) {
    e.preventDefault();
    menuOpen = !menuOpen

    if (menuOpen) {
      menuBurgerAnim.setDirection(1)
      menuBurgerAnim.play()
      $('body').width($('body').width())
      $('html').css({
        'overflow': 'hidden',
        'height': '100%'
      })

      $(document).on('touchmove', function(e) {
        e.preventDefault()
      })

    } else {
      menuBurgerAnim.setDirection(-1)
      menuBurgerAnim.play()
      $('body').width('100%')
      $('html').css({
        'overflow': 'auto',
        'height': 'auto'
      })

      $(document).unbind('touchmove')
    }

    $('.navbar-brand').toggleClass('open')
    $('.navbar-menu').toggleClass('open')
    $('.navbar-buttons').toggleClass('open')
    $('.m-menu-overlay').toggleClass('open')
  })

  $('.m-menu-overlay a').click(function(e) {
    e.preventDefault();
    menuBurger.click()

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 1500);
  })

  if ($('#m-suit-right').length) {
    particlesJS.load('m-suit-right', 'data/particles.json');
  }

  let mCarousel = $('.m-carousel');

  if (mCarousel.length) {
    mCarousel.on('initialized.owl.carousel', (event) => {
      $.each(document.querySelectorAll('.m-carousel-icon-bg'), (index, elem) => {
        new Parallax(elem);
      })
    })

    mCarousel.owlCarousel({
      loop: false,
      autoplay: true,
      rewind: true,
      margin: 20,
      stagePadding: 15,
      autoplayHoverPause: true,
      responsive:{
        0: {
          items: 1
        },
        768: {
          items: 2
        },
        992: {
          items: 3
        }
      }
    })
  }

  $('.m-roadmap').owlCarousel({
    loop: false,
    margin: 70,
    stagePadding: 0,
    nav: false,
    items: 5,
    autoWidth: true
  })

  $('.m-carousel-nav-left').click((e) => {
    e.preventDefault();
    mCarousel.trigger('prev.owl.carousel')
  })

  $('.m-carousel-nav-right').click((e) => {
    e.preventDefault();
    mCarousel.trigger('next.owl.carousel')
  })

  let testimonialsCarousel = $('.testimonials-slider');

  testimonialsCarousel.owlCarousel({
    loop: true,
    autoplay: false,
    margin: 0,
    stagePadding: 0,
    nav: false,
    items: 1
  })

  $('.m-testimonials-block .arrows .arrow-prev').click((e) => {
    e.preventDefault();
    testimonialsCarousel.trigger('prev.owl.carousel')
  })

  $('.m-testimonials-block .arrows .arrow-next').click((e) => {
    e.preventDefault();
    testimonialsCarousel.trigger('next.owl.carousel')
  })

  $('.m-icon').cycle()

  $('.m-top').click(() => {
    $('html, body').animate({ scrollTop: 0 }, 1500)
    return false
  })

  $('.m-team-card-wrapper').flip({
    trigger: 'manual',
    front: '.m-team-card-front',
    back: '.m-team-card-back'
  });

  $('.btn-flip').click(function (e) {
    e.preventDefault();
    $(this).closest('.m-team-card-wrapper').flip(true)
  })

  $('.btn-unflip').click(function () {
    $(this).closest('.m-team-card-wrapper').flip(false)
  })

  let showAllTeam = false
  let showTeamOrgText = $('.m-team-show-btn a').text()

  $('.m-team-show-btn a').click(function(e) {
    e.preventDefault()
    showAllTeam = !showAllTeam

    if (showAllTeam) {
      $(this).text('show less')
    } else {
      $(this).text(showTeamOrgText)
      $('html, body').animate({
        scrollTop: ($('.m-team .m-team-card-wrapper:eq(2)').offset().top - $('.navbar-wrapper').height())
      }, 500);
    }

    $.each($('.m-team .m-team-card-wrapper'), (index, elem) => {
      if ($(elem).hasClass('hide')) {
        $(elem).removeClass('hide').addClass('show')
      } else if ($(elem).hasClass('show')) {
        $(elem).removeClass('show').addClass('hide')
      }
    })
  })

  if ($('.m-news-3dots').length) {
    $.each(document.querySelectorAll('.m-news-3dots'), (index, elem) => {
      lottie.loadAnimation({
        container: elem,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: 'data/3dots.json',
        name: '3dots'
      })
    })

    $('.m-news-card').hover(
      function() {
        let threeDots = $(this).find('.m-news-3dots')
        threeDots.css('opacity', '1')
        lottie.play('3dots')
      },
      function() {
        let threeDots = $(this).find('.m-news-3dots')
        threeDots.css('opacity', '0')
        lottie.stop('3dots')
      }
    )
  }

  var circleOffset;
  var circle;
  var circleFromTop;

  if ($('.radial-progress').length) {
    circleOffset = ($(window).height() / 3);
    circle = $('.radial-progress');
    circleFromTop = circle.offset().top - circleOffset;
  }

  function setCirclePercent() {
    if ($(window).scrollTop() >= circleFromTop) {
      var percent = Math.floor(($(window).scrollTop() - circleFromTop) / 2);

      if (percent > 0 && percent < 100) {
        $('.radial-progress').attr('data-progress', percent)
        $('.mini-circle-wrapper').css('transform', 'rotate(' + (percent * 1.8) * 2 + 'deg)')
      } else if (percent >= 100) {
        $('.radial-progress').attr('data-progress', 100)
        $('.mini-circle-wrapper').css('transform', 'rotate(360deg)')
      }

    } else if ($(window).scrollTop() <= circleFromTop) {
      $('.radial-progress').attr('data-progress', 0)
      $('.mini-circle-wrapper').css('transform', 'rotate(0deg)')
    }
  }

  function setAffix(offset = 0) {
    var scroll = $(window).scrollTop();

    if (scroll >= offset) {
      $('.navbar-wrapper').addClass('affix');
      $('.navbar-menu').addClass('affix-menu');

      if (!($('.navbar').parent().hasClass('container-fluid'))) {
        $('.navbar').wrap('<div class="container-fluid"></div>');
      }

    } else {
      $('.navbar-wrapper').removeClass('affix');
      $('.navbar-menu').removeClass('affix-menu');

      if ($('.navbar').parent().hasClass('container-fluid')) {
        $('.navbar').unwrap();
      }
    }
  }

  $(window).scroll(function() {
    setAffix(300);

    if ($('.radial-progress').length) {
      setCirclePercent()
    }
  });

  $(window).on('touchmove', function() {
    setAffix(300);
  });

  if ($(window).width() <= 976) {
    if ($('.m-structure svg').css('height') === '588px') {
      $('.m-structure svg').css('height', '728px')
      $('.m-structure svg').removeAttr('viewBox');
      $('.m-structure svg').each(function () { $(this)[0].setAttribute('viewBox', '0 0 703 668') });
    }

    $('.m-ecosystem .parent .child').hide();
    $('.m-ecosystem .parent').unbind('click').click(function(e) {
      var children = $(this).find('.child')
      children.slideToggle('fast')
    })
  } else if ($(window).width() >= 977) {
    if ($('.m-structure svg').css('height') === '728px') {
      $('.m-structure svg').css('height', '588px')
      $('.m-structure svg').removeAttr('viewBox');
      $('.m-structure svg').each(function () { $(this)[0].setAttribute('viewBox', '0 0 703 528') });
    }

    $('.m-ecosystem .parent .child').show();
    $('.m-ecosystem .parent').unbind('click');
  }

  $(window).resize(function() {
    if ($(this).width() <= 976) {
      // mobile
      if ($('.m-structure svg').css('height') === '588px') {
        $('.m-structure svg').css('height', '728px')
        $('.m-structure svg').removeAttr('viewBox');
        $('.m-structure svg').each(function () { $(this)[0].setAttribute('viewBox', '0 0 703 668') });
      }

      $('.m-ecosystem .parent .child').hide();
      $('.m-ecosystem .parent').unbind('click').click(function(e) {
        var children = $(this).find('.child')
        children.slideToggle('fast')
      })
    } else if ($(this).width() >= 977) {
      // desktop
      if ($('.m-structure svg').css('height') === '728px') {
        $('.m-structure svg').css('height', '588px')
        $('.m-structure svg').removeAttr('viewBox');
        $('.m-structure svg').each(function () { $(this)[0].setAttribute('viewBox', '0 0 703 528') });
      }

      $('.m-ecosystem .parent .child').show();
      $('.m-ecosystem .parent').unbind('click');
    }
  })

  var fullOpacity = '1'
  var textHoverOpacity = '0.5'

  $.each($('#top-block').children(), function(index, element) {
    if (index == 0) {
      return
    }

    $('#top-square-' + index).hover(function() {
      $('.top-block-text .title').css('opacity', fullOpacity)
      $('.top-block-text .subtitle[data-id=' + index + ']').css('opacity', fullOpacity)
      $('#top-block, .top-block-text').css({
        '-webkit-animation-play-state': 'paused',
        '-moz-animation-play-state': 'paused',
        '-o-animation-play-state': 'paused',
        'animation-play-state': 'paused'
      })
    }, function() {
      $('.top-block-text .title').css('opacity', textHoverOpacity)
      $('.top-block-text .subtitle[data-id=' + index + ']').css('opacity', textHoverOpacity)
      $('#top-block, .top-block-text').css({
        '-webkit-animation-play-state': 'running',
        '-moz-animation-play-state': 'running',
        '-o-animation-play-state': 'running',
        'animation-play-state': 'running'
      })
    })
  })

  $('#second-block-wrapper').hover(function() {
    $('.second-block-text p').css({
      'transform': 'translateX(10px)',
      'opacity': fullOpacity
    })
    $('#second-block-wrapper, .second-block-text').css({
      '-webkit-animation-play-state': 'paused',
      '-moz-animation-play-state': 'paused',
      '-o-animation-play-state': 'paused',
      'animation-play-state': 'paused'
    })
  }, function() {
    $('.second-block-text p').css({
      'transform': 'translateX(0px)',
      'opacity': textHoverOpacity
    })
    $('#second-block-wrapper, .second-block-text').css({
      '-webkit-animation-play-state': 'running',
      '-moz-animation-play-state': 'running',
      '-o-animation-play-state': 'running',
      'animation-play-state': 'running'
    })
  })

  $('#third-block-wrapper').hover(function() {
    $('.third-block-text p').css({
      'opacity': fullOpacity,
      'transform': 'translateX(-10px)'
    })
    $('#third-block-wrapper, .third-block-text').css({
      '-webkit-animation-play-state': 'paused',
      '-moz-animation-play-state': 'paused',
      '-o-animation-play-state': 'paused',
      'animation-play-state': 'paused'
    })
  }, function() {
    $('.third-block-text p').css({
      'opacity': textHoverOpacity,
      'transform': 'translateX(0px)'
    })
    $('#third-block-wrapper, .third-block-text').css({
      '-webkit-animation-play-state': 'running',
      '-moz-animation-play-state': 'running',
      '-o-animation-play-state': 'running',
      'animation-play-state': 'running'
    })
  })

  $('#fourth-block-wrapper').hover(function() {
    $('.fourth-block-text p').css({
      'opacity': fullOpacity,
      'transform': 'translateX(10px)'
    })
    $('#fourth-block-wrapper, .fourth-block-text').css({
      '-webkit-animation-play-state': 'paused',
      '-moz-animation-play-state': 'paused',
      '-o-animation-play-state': 'paused',
      'animation-play-state': 'paused'
    })
  }, function() {
    $('.fourth-block-text p').css({
      'opacity': textHoverOpacity,
      'transform': 'translateX(0px)'
    })
    $('#fourth-block-wrapper, .fourth-block-text').css({
      '-webkit-animation-play-state': 'running',
      '-moz-animation-play-state': 'running',
      '-o-animation-play-state': 'running',
      'animation-play-state': 'running'
    })
  })

  $('#fifth-block-wrapper').hover(function() {
    $('.fifth-block-text p').css({
      'opacity': fullOpacity,
      'transform': 'translateX(-10px)'
    })
    $('#fifth-block-wrapper, .fifth-block-text').css({
      '-webkit-animation-play-state': 'paused',
      '-moz-animation-play-state': 'paused',
      '-o-animation-play-state': 'paused',
      'animation-play-state': 'paused'
    })
  }, function() {
    $('.fifth-block-text p').css({
      'opacity': textHoverOpacity,
      'transform': 'translateX(0px)'
    })
    $('#fifth-block-wrapper, .fifth-block-text').css({
      '-webkit-animation-play-state': 'running',
      '-moz-animation-play-state': 'running',
      '-o-animation-play-state': 'running',
      'animation-play-state': 'running'
    })
  })

  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 100;
  var delta = 100;
  var navbarHeight = $('.navbar-wrapper.affix').outerHeight();

  $(window).scroll(function(event){
    didScroll = true;
  });

  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 100);

  function hasScrolled() {
    var st = $(window).scrollTop();

    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
      return;

      // If they scrolled down and are past the navbar, add class .nav-up.
      // This is necessary so you never see what is "behind" the navbar.
      if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('.navbar-wrapper').removeClass('nav-down').addClass('nav-up');
        $('.navbar-menu').removeClass('nav-down').addClass('nav-up');
      } else if (st <= 300) {
        $('.navbar-menu').removeClass('nav-down');
      } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
          $('.navbar-wrapper').removeClass('nav-up').addClass('nav-down');
          $('.navbar-menu').removeClass('nav-up').addClass('nav-down');
        }
      }

      lastScrollTop = st;
  }

  $(window).bind('mousewheel DOMMouseScroll', function (e) {
    if (((e.ctrlKey || e.metaKey)) == true) {
      e.preventDefault();
    }
  });

  $('[data-toggle="tooltip"]').tooltip()

  if ($('.m-concept-block').length) {
    var gradientFaded = false;

    if (MOBILE) {
      $('.m-concept-block .text .text-wrapper').readmore({
        moreLink: '<a href="#" class="btn btn-medo-dark-blue">read more</a>',
        lessLink: '<a href="#" class="btn btn-medo-dark-blue">read less</a>',
        collapsedHeight: 190
      }).css('height', 'auto');
    } else {
      $('.m-concept-block .text .text-wrapper').customScrollbar({
        skin: 'default-skin',
        hScroll: false,
        updateOnWindowResize: true,
        onCustomScroll: function() {
          if (!gradientFaded) {
            $('.m-concept-block .text .gradient').fadeOut('slow')
          }

          gradientFaded = true;
        }
      });

      let conceptInstance = basicScroll.create({
        elem: document.querySelector('.m-concept-block'),
        from: 'top-bottom',
        to: 'bottom-middle',
        props: {
          '--translateY': {
            from: '0',
            to: '-500px'
          }
        }
      })

      conceptInstance.start();

      $('.m-faq-block h6').each(function(index) {
        $(this).click(function() {
          conceptInstance.stop()
          conceptInstance.update()
          conceptInstance.start()
        });
      });
    }
  }

  if($('#m-dividends-block').length) {
    new Vue({
      el: '#m-dividends-block',
      data() {
        return {
          value: 30000,
          options: {
            eventType: 'auto',
            width: '100%',
            height: 8,
            dotSize: 14,
            dotHeight: null,
            dotWidth: null,
            min: 1000,
            max: 100000,
            interval: 500,
            show: true,
            speed: 0.5,
            disabled: false,
            piecewise: false,
            piecewiseLabel: false,
            tooltip: 'always',
            tooltipDir: 'bottom',
            reverse: false,
            data: null,
            clickable: true,
            realTime: false,
            lazy: false,
            formatter: null,
            bgStyle: null,
            sliderStyle: null,
            processStyle: null,
            piecewiseActiveStyle: null,
            piecewiseStyle: null,
            tooltipStyle: null,
            labelStyle: null,
            labelActiveStyle: null
          }
        }
      },
      computed: {
        payout: function() {
          let payoutValue = this.value * 82.3
          return payoutValue.toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1,')
        },
        investmentReturn: function() {
          let percent = this.value / 4.5
          return percent.toFixed()
        }
      },
      components: {
        'vueSlider': window[ 'vue-slider-component' ]
      }
    })

    $('.vue-slider-dot').append('<div class="small-dot"></div>')
    $('.vue-slider-dot').append('<div class="big-dot"></div>')
  }

});
